import Immutable from 'seamless-immutable';
// ---- external imports ----

import { getEmptyFinancialRatios } from '~/models/FinancialRatios';
import { levelSelectors, employeesSelectors, turnSelectors } from '~/store';
import { LEVELS_TO_UNLOCK_FEATURES } from '~/lib/constants';
// ---- internal imports ----

import { getFinancialStatementsFor, getSystemFinancialStatementsFor, isFinancialStatementsSubmittedForQuarter } from './';
// ---- local imports ----


export function doesQuarterHasFinancialRatios(state, quarterNum) {
	const systemFinancialStatement = getSystemFinancialStatementsFor(state, quarterNum);

	return !!systemFinancialStatement?.financialRatios;
}

export function isFinancialRatiosCardOpen(state) {
	return state.financialStatements.isFinancialRatiosCardOpen;
}

export function getFinancialRatiosFor(state, quarterNum) {
	const financialStatement = getFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.financialRatios) {
		return financialStatement.financialRatios;
	}
	else {
		return new Immutable(getEmptyFinancialRatios());
	}
}

export function getSystemFinancialRatiosFor(state, quarterNum) {
	const financialStatement = getSystemFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.financialRatios) {
		return financialStatement.financialRatios;
	}
	else {
		return new Immutable(getEmptyFinancialRatios());
	}
}

export function hasAutomatedFinancialRatios(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.FINANCIAL_RATIOS_EDIT
		|| employeesSelectors.hasFinancialRatiosAutomatorHired(state);
}

export function isFinancialRatiosAutomatedForQuarter(state, quarterNum) {
	return state.financialStatements.isFinancialRatiosAutomatedByQuarter[quarterNum];
}

export function getFinancialRatiosErrorField(state) {
	return state.financialStatements.financialRatiosErrorField;
}

export function isFinancialRatiosSubmittedForQuarter(state, quarterNum) {
	const lastQuarter = turnSelectors.getCurrentQuarterNum(state) - 1;

	if (quarterNum > lastQuarter) {
		throw new Error("Invalid Quarter Number");
	}

	if (lastQuarter === quarterNum) {
		return state.financialStatements.isFinancialRatiosSubmittedForLastQuarter;
	}

	return true;
}

export function getHasAttemptedToSubmitFinancialRatios(state) {
	return state.financialStatements.hasAttemptedToSubmitFinancialRatios;
}

export function shouldAutomaticallyOpenFinancialRatios(state, quarterNum) {
	const lastQuarter = turnSelectors.getCurrentQuarterNum(state) - 1;

	if (quarterNum !== lastQuarter) {
		return false;
	}

	const hasSubmittedFinancialStatements = isFinancialStatementsSubmittedForQuarter(state, quarterNum);

	const hasSubmittedFinancialRatios = isFinancialRatiosSubmittedForQuarter(state, quarterNum);

	return hasSubmittedFinancialStatements && !hasSubmittedFinancialRatios;
}
